// submitMessageRating.js
'use strict';
import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import getMeData from '../selector/getMeData.js';
import getMessageData from '../selector/getMessageData.js';

import pushToastr from '../action/pushToastr.js';

import {
  ADD_MESSAGE,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Submit message rating
 * @kind action
 * @param {string} { id } - message id.
 * @param {number} { rating } - rating number, only allow two values 0 and 100.
 * @return {Promise} Action promise.
 */
const submitMessageRating =
  ({ id, rating }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');
    if (!token) {
      return dispatch({ type: '' });
    }

    const isUnlocked = getMessageData(getState(), id, 'canViewMedia');
    if (!isUnlocked) {
      return dispatch(
        pushToastr({
          textKey: 'toast_review_after_unlock',
          color: 'error',
        })
      );
    }

    const selectPath = ['messages', id, 'rating'];

    const url = getResourceUrl({ endpoint: `/messages/${id}/rate` });
    const fetchOptions = {
      method: 'PUT',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ rating }),
    };

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      dispatch({ type: ADD_MESSAGE, payload: { ratedAs: rating, id } });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default submitMessageRating;
